import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=f906bf10&"
import script from "./FooterBar.vue?vue&type=script&lang=js&"
export * from "./FooterBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\www\\aliventa\\gruene-hex\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f906bf10')) {
      api.createRecord('f906bf10', component.options)
    } else {
      api.reload('f906bf10', component.options)
    }
    module.hot.accept("./FooterBar.vue?vue&type=template&id=f906bf10&", function () {
      api.rerender('f906bf10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FooterBar.vue"
export default component.exports